module.exports = __webpack_public_path__ + "static/media/about-partner-carousel-5.cc371481.png";